import { Controller } from "@hotwired/stimulus"
import { useRender, html } from "stimulus-lit"

export class ConsultancyDrawerController extends Controller<HTMLDivElement> {
  static values = { src: String, name: String }
  declare srcValue?: String
  declare nameValue?: String

  connect() {
    useRender(this)
    addEventListener("popstate", this.reset)
  }

  disconnect() {
    removeEventListener("popstate", this.reset)
  }

  open(event: PointerEvent) {
    if (!event.metaKey) {
      event.preventDefault()

      const link = event.target as HTMLLinkElement
      this.srcValue = link.href
      this.nameValue = link.dataset.name
    }
  }

  reset = () => (this.srcValue = undefined)

  // @ts-ignore
  pushState = () => Turbo.navigator.history.push(new URL(this.srcValue))

  render() {
    return html`
      <sl-drawer class="company-drawer" ?open=${!!this.srcValue} @sl-request-close=${() => history.back()}>
        <div slot="label">
          <sl-breadcrumb>
            <sl-breadcrumb-item>Consultancies</sl-breadcrumb-item>
            <sl-breadcrumb-item>${this.nameValue}</sl-breadcrumb-item>
          </sl-breadcrumb>
        </div>

        ${this.srcValue &&
        html`<turbo-frame id="consultancy_show" src="${this.srcValue}" @turbo:frame-render=${this.pushState}>
          <div class="mb-4 flex items-center">
            <sl-skeleton class="mb-4 mr-4 w-12 h-12 float-left"></sl-skeleton>
            <sl-skeleton class="mb-4 w-1/3"></sl-skeleton>
          </div>

          <sl-skeleton class="mb-4"></sl-skeleton>
          <sl-skeleton class="mb-4 w-4/5"></sl-skeleton>
          <sl-skeleton class="mb-4 w-3/4"></sl-skeleton>
        </turbo-frame>`}
      </sl-drawer>
    `
  }
}
